
{
  "familyId": "SPR-TREMA-MV",
  "questions": [
    {
      "id": "SPR-TREMA-MV-001",
      "familyId": "SPR-TREMA-MV",
      "module": "SpellingRegel",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leestekens",
      "subSkill": "trema_meervoud",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["geëerd", "geeerd", "ge-eerd", "geëert"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Trema na ge-", "content": "Na voorvoegsels zoals 'ge-' gebruik je een trema (¨) om te laten zien dat je twee klinkers apart uitspreekt: ge-ëerd (niet 'geeerd' wat zou klinken als 'geerd').", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "diaeresis_usage",
      "variantIndex": 1,
      "feedback": { "explanationText": "Na 'ge-' gebruik je een trema om de twee e's apart uit te spreken: geëerd. Zonder trema zou je 'geerd' lezen, wat fout is.", "distractorExplanations": { "0": "Correct! Het trema zorgt dat je beide e's apart uitspreekt: ge-ëerd.", "1": "Fout: zonder trema lees je 'geerd'. Je hebt een trema nodig: geëerd.", "2": "Fout: je schrijft geen streepje, maar een trema: geëerd.", "3": "Fout: de uitgang is -d, niet -t. En je hebt een trema nodig: geëerd." } }
    }
  ]
}
